import { render, staticRenderFns } from "./BasePageTitle.vue?vue&type=template&id=c18d1564"
import script from "./BasePageTitle.vue?vue&type=script&lang=js"
export * from "./BasePageTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports